import React, { createContext, useEffect, useMemo, useContext, useState } from 'react';
import io from 'socket.io-client'
import { useApi } from './api';

// const development: boolean = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';

interface SPIRTCInfo {
    url: string;
    token: string;
}

const createHubConnection = (info: SPIRTCInfo) => {
    return io(info.url, {
        query: { 'apikey': info.token }
    });
}

export interface SpiRTCContextProps {
    hub?: SocketIOClient.Socket
    userId?: string;
}

export const SpiRTCContext = createContext<SpiRTCContextProps>({});

export const SpiRTCProvider = (props: any) => {
    const [hub, setHub] = useState<SocketIOClient.Socket | undefined>(undefined);

    const { user, api } = useApi();

    useEffect(() => {

        if (!user) return;

        let lHub: SocketIOClient.Socket | undefined;

        const connectHub = async () => {
            try {

                const info = await api.get<{ url: string, token: string }>('spi-rtc/info');

                lHub = createHubConnection(info.data);

                lHub.on('auth', (args: any, result: any) => {
                    result({
                        appName: 'apc-mobile-web',
                        userId: user?.id,
                        interests: ["vendaTotalizada"]
                    });
                })


                lHub.open();
                setHub(lHub);

            } catch (error) {

            }
        }

        connectHub();

        return () => {
            lHub?.off('users');
            lHub?.off('auth');
            lHub?.disconnect();
        }

    }, [user, api]);


    const contextData = useMemo(() => ({ hub: hub, userId: user?.id }), [hub, user]);

    return <SpiRTCContext.Provider value={contextData} {...props} />
};

export const useSpiRTCContext = (): SpiRTCContextProps => useContext(SpiRTCContext);